import { Divider, DividerProps } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

/**
 * enum for specifying whether the divider should be in horizontal/vertical
*/
export enum DividerOrientation {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal'
}

/**
 * enum for specifying the divider width 
*/
export enum DividerVariant {
    FULLWIDTH = 'fullWidth',
    MIDDLE = 'middle',
    INSET = 'inset'
}

/**
 * Interface for defining props of CcfDivider component
*/
export interface CcfDividerProps extends DividerProps {
  orientation: DividerOrientation;
  variant: DividerVariant;
  absolute?: boolean;
  light?: boolean;
  flexItem?: boolean; //if it's true in vertical orientation just make sure you are giving a heigth
  className?: string;
}

const useStyles = makeStyles((theme) => ({

}));

/**
 * Component used to display divider
 * @param orientaion - DividerOrientation
 * @param variant - DividerVariant
 * @param absolute - boolean
 * @param light - boolean
 * @param flexItem - boolean it's mainly for vertical divider
 * @param className - component class
 * @example <CcfDivider />
 * @returns divider
 */
export function CcfDivider({orientation = DividerOrientation.HORIZONTAL, variant = DividerVariant.FULLWIDTH, absolute = false, light = false, flexItem = false, className='', sx={}}: CcfDividerProps) {
  const styles = useStyles();
  return (
    <Divider orientation={orientation} variant={variant} absolute={absolute} light={light} flexItem={flexItem} className={className} sx={{...sx}}/>
  );
}

export default CcfDivider;
